import * as api from '../api/appraiserSettings';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_APPRAISER_TYPES = createRequestTypes(
  `${prefix}/FETCH_APPRAISER_TYPES`,
);

export const fetchAppraiserTypes = makeApiActionCreatorV3(
  api.fetchAppraiserTypes,
  FETCH_APPRAISER_TYPES[START],
  FETCH_APPRAISER_TYPES[SUCCESS],
  FETCH_APPRAISER_TYPES[ERROR],
);

export const FETCH_APPRAISER_SETTINGS = createRequestTypes(
  `${prefix}/FETCH_APPRAISER_SETTINGS`,
);

export const fetchAppraiserSettings = makeApiActionCreatorV3(
  api.fetchAppraiserSettings,
  FETCH_APPRAISER_SETTINGS[START],
  FETCH_APPRAISER_SETTINGS[SUCCESS],
  FETCH_APPRAISER_SETTINGS[ERROR],
);

export const INSERT_APPRAISER_SETTINGS = createRequestTypes(
  `${prefix}/INSERT_APPRAISER_SETTINGS`,
);

export const insertAppraiserSettings = makeApiActionCreatorV3(
  api.insertAppraiserSettings,
  INSERT_APPRAISER_SETTINGS[START],
  INSERT_APPRAISER_SETTINGS[SUCCESS],
  INSERT_APPRAISER_SETTINGS[ERROR],
);
